import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

/** Performance Max in Gmail (mobile): inbox row with a landscape thumbnail and headline. */
@Component({
    selector: 'app-pmax-gmail-mobile-02',
    imports: [CommonModule, MobileFrameComponent],
    templateUrl: './gmail-mobile-02.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './gmail-mobile-02.component.scss'
})
export class PmaxGmailMobile02PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Row count for the skeleton inbox below the ad. */
  readonly inboxSkeletonRows = Array.from({ length: 5 });

  /** This placement's creative slot is the 1.91:1 landscape format. */
  readonly creativeFormat: CreativeFormat = 'landscape';

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }
}
